
    const data = {"name":"src/core/icons/store-plus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 4v2h16V4M4 7l-1 5v2h1v6h9c-.05-.34-.08-.69-.08-1.05 0-1.22.38-2.42 1.08-3.42V14h1.54c1-.67 2.17-1.04 3.37-1.04.71 0 1.42.13 2.09.38V12l-1-5M6 14h6v4H6m12-3v3h-3v2h3v3h2v-3h3v-2h-3v-3\"/>","originalColors":[],"stopColors":[]}}

            export default data
            